import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Link, useSearchParams } from 'react-router-dom';
import { resetPassword } from './authApi';

const { Title, Text } = Typography;

export default function ResetPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await resetPassword({ token, password: values.password });
      setDone(true);
      message.success('Password reset successfully!');
    } catch (err) {
      const msg = err.response?.data?.title || 'Reset failed';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ maxWidth: 400, margin: '80px auto', padding: '0 16px' }}>
        <Card style={{ borderRadius: 12 }}>
          <Result
            status="error"
            title="Invalid reset link"
            subTitle="This link is missing the reset token. Please request a new one."
          />
          <div style={{ textAlign: 'center' }}>
            <Link to="/forgot-password">Request new reset link</Link>
          </div>
        </Card>
      </div>
    );
  }

  if (done) {
    return (
      <div style={{ maxWidth: 400, margin: '80px auto', padding: '0 16px' }}>
        <Card style={{ borderRadius: 12 }}>
          <Result
            status="success"
            title="Password reset!"
            subTitle="Your password has been changed successfully."
          />
          <div style={{ textAlign: 'center' }}>
            <Link to="/login">Sign in with new password</Link>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 400, margin: '80px auto', padding: '0 16px' }}>
      <Card style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ margin: 0 }}>Set new password</Title>
          <Text type="secondary">Must be at least 8 characters</Text>
        </div>

        <Form layout="vertical" onFinish={handleSubmit} size="large">
          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Please enter a password' },
              { min: 8, message: 'Password must be at least 8 characters' },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="New password" />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Confirm password" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
